import { render, staticRenderFns } from "./ArticleTemplate.vue?vue&type=template&id=9cb06a20&scoped=true&"
import script from "./ArticleTemplate.vue?vue&type=script&lang=js&"
export * from "./ArticleTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTemplate.vue?vue&type=style&index=0&id=9cb06a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb06a20",
  null
  
)

export default component.exports